import { render, staticRenderFns } from "./ItemCalculation.vue?vue&type=template&id=4e0b6528&scoped=true"
import script from "./ItemCalculation.vue?vue&type=script&lang=js"
export * from "./ItemCalculation.vue?vue&type=script&lang=js"
import style0 from "./ItemCalculation.vue?vue&type=style&index=0&id=4e0b6528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b6528",
  null
  
)

export default component.exports